module.exports = __webpack_public_path__ + "static/img/government_bg1.c8ce6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/government_bg1.png
// module id = MDK0
// module chunks = 44